import { createI18n } from 'vue-i18n';

import { getBrowserLocale } from '@/utils/browserLangDetector.util';

import { es } from './es';
import { fr } from './fr';

const translates = {
  es,
  fr,
};

const langPref = () => {
  const navigatorLocal = getBrowserLocale({ countryCodeOnly: true });
  if (navigatorLocal !== null && Object.keys(translates).includes(navigatorLocal)) {
    return navigatorLocal;
  }
  return 'fr';
};

export const i18n = createI18n({
  legacy: false,
  locale: langPref(),
  fallbackLocale: langPref(),
  messages: translates,
});
